import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'twc-info-page-skeleton',
  imports: [],
  templateUrl: './info-page-skeleton.component.html',
  styleUrls: ['./info-page-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoPageSkeletonComponent {}
